<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :loading="buttonLoading"
                color="success"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>
                Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="reprintDailyReport('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllRetailSale()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                :rules="[() => !!queryParams.shopId || 'Shop is required.']"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Sales:</span>
              <v-chip>
                <span>{{ totalSale | decFormat(6) }}</span>
              </v-chip>
            </div>
            <div>
              <span>Total Cash Sales:</span>
              <v-chip>
                <span>{{ totalCashSale | decFormat(6) }}</span>
              </v-chip>

              <span>Total Credit Sales:</span>
              <v-chip>
                <span>{{ totalCreditSale | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="dailySaleReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{ props.item.dateInMilliSeconds | format-ms-date }}
              </td>
              <td style="text-align: right">
                {{ props.item.cashSale | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.creditSale | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.totalSale | decFormat(6) }}
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- <summary report> -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">
          {{ shopName }} ({{ shopCode }})
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">Daily Sale Report By Date</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: left">Item</th>
              <th style="border: 1px solid black; text-align: left">Date</th>
              <th style="border: 1px solid black; text-align: right">
                Cash Sales
              </th>
              <th style="border: 1px solid black; text-align: right">
                Credit Sales
              </th>
              <th style="border: 1px solid black; text-align: right">
                Total Sales
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allDailySaleReportList" :key="index">
              <td style="border: 1px solid black; text-align: left">
                {{ index + 1 }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.dateInMilliSeconds | format-ms-date }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.cashSale | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.creditSale | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.totalSale | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="2"
              >
                Grand Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ totalCashSale | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ totalCreditSale | decFormat(6) }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ totalSale | decFormat(6) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { saleReportService } from "../../services/sale-report-service";
import { shopService } from "../../services/shop-service";
export default {
  name: "DailySaleReport",
  components: {},

  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Report",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Daily Sale Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Date", align: "left", value: "date" },
      { text: "Cash Sales", value: "cashSale" },
      { text: "Credit Sales", value: "creditSale" },
      { text: "Total Sales", value: "totalSale" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      sortBy: "null",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
    },
    dailySaleReportList: [],
    allDailySaleReportList: [],
    shopList: [],
    totalSale: 0,
    totalCashSale: 0,
    totalCreditSale: 0,
    clonequeryParams: new Object(),
    shopName: "",
    shopCode: "",
  }),
  watch: {
    pagination: {
      handler() {
        this.getDailySale();
      },
      deep: true,
    },
  },

  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getShopList();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "daily-sale-report",
        query: this.queryParams,
      });
      this.getDailySale();
      this.clonequeryParams = Object.assign({}, this.queryParams);

      let shop = commonService.search(
        "id",
        this.queryParams.shopId,
        this.shopList
      );
      if (shop) {
        this.shopName = shop.name;
        this.shopCode = shop.code;
      }
    },

    getDailySale() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      saleReportService
        .getDailySaleReport(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.dailySaleReportList = res.data.dailySaleReportList;
            this.totalRows = res.data.totalElements;
            this.totalSale = res.data.totalSale;
            this.totalCashSale = res.data.totalCashSale;
            this.totalCreditSale = res.data.totalCreditSale;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },

    reprintDailyReport(divName) {
      this.buttonLoading = true;
      saleReportService
        .getAllDailySaleReportList(this.clonequeryParams)
        .then((res) => {
          this.allDailySaleReportList = res.data.dailySaleReportList;
          this.totalSale = res.data.totalSale;
          this.totalCreditSale = res.data.totalCreditSale;
          this.totalCashSale = res.data.totalCashSale;
          console.log(this.allDailySaleReportList);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },

    exportAllRetailSale() {
      this.buttonLoading = true;
      saleReportService
        .getSaleReportExcelExport(this.clonequeryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
  },
};
</script>